import React from 'react';
import ProgressRing from './ProgressRing';
import SkeletonLoader from './SkeletonLoader';
import './AnalysisProgress.css';

function AnalysisProgress({ analysisData }) {
  const getStatusMessage = () => {
    if (!analysisData) return 'Iniciando...';
    
    const { phase, status, current_url, urls_processed, total_urls } = analysisData;
    
    if (phase === 'crawling' && current_url) {
      return `${status}: ${current_url}`;
    }
    if (phase === 'summarizing' && current_url) {
      return 'Finalizando análisis';
    }
    if (phase === 'analyzing') {
      return 'Completando análisis final';
    }
    
    return status || 'Procesando...';
  };

  const getProgressInfo = () => {
    if (!analysisData) return '';
    
    const { urls_processed, total_urls, phase, status } = analysisData;

    if (status && (status.includes('Iniciando navegación') || status.includes('Finalizando análisis'))) {
      return '';
    }
    
    if (phase === 'crawling' || phase === 'summarizing' && total_urls > 0) {
      return `(${urls_processed}/${total_urls} páginas)`;
    }
    
    return '';
  };

  return (
    <div className="analysis-progress-container">
      <div className="progress-header">
        <ProgressRing progress={analysisData?.progress || 0} />
        <div className="progress-status">
          <div className="status-text">{getStatusMessage()}</div>
          <div className="progress-info">{getProgressInfo()}</div>
        </div>
      </div>
      <SkeletonLoader />
    </div>
  );
}

export default AnalysisProgress;